<template>
  <div class="supervisor-list" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="优选工长" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="search-container">
      <div class="search">
        <div class="input">
          <img src="../../assets/icon/icon-search.png" class="search-icon">
          <input v-model="searchKeyword" placeholder="搜索工长" class="input-inner" @keydown.enter="search"/>
        </div>
        <div class="btn" @click="search">搜索</div>
      </div>
      <div class="border"></div>
    </div>
    <div class="supervisor-item" v-for="(foreman,index) in gangmasterListFiltered" v-if="gangmasterListFiltered.length > 0">
      <img class="supervisor-avatar" :src="imgUrl + foreman.avatar" @click="DetailGangmaster(foreman)">
      <div class="supervisor-info" @click="DetailGangmaster(foreman)">
        <div class="first-line">
          <div class="left">
            <div class="name">{{foreman.name}}</div>
            <div class="score-part">
              <div class="score">{{foreman.score | serviceScoreConvert}}</div>
            </div>
          </div>
        </div>
        <div class="appointment-info"><img src="../../assets/icon-appointment-num.png"/>预约名额<span class="num">{{foreman.spares}}</span></div>
        <div class="less-info">
          <div class="case-info"><img src="../../assets/icon-case-num.png"/>案例<span class="num">{{foreman.projectCount}}</span></div>
          <div class="case-info" v-if="foreman.deposit"><img src="../../assets/icon-app-deposit.png"/>订金<span class="num deposit">{{foreman.deposit}}</span></div>
        </div>
      </div>

      <div v-if="foreman.spares != 0" class="appoint-btn" @click="openGangmasterReservation(foreman)">
        预 约
      </div>
      <div v-if="foreman.spares == 0" class="full-btn" @click="openGangmasterReservation(foreman)">
        已 满
      </div>
    </div>
    <div v-if="inited && gangmasterListFiltered.length === 0" class="noimg">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">未找到工长</div>
    </div>
  </div>
</template>

<script>
  import { imgUrl } from '../../config'
  import { Toast } from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import SupervisorService from '../../service/SupervisorService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'GangmasterSeekSearch',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        gangmasterList:[],
        inited:false,
        imgUrl: imgUrl,
        isWechatBrowser:this.$verfyBrowserType(),
        filterText:'',
        searchKeyword:'',
      }
    },
    computed: {
      gangmasterListFiltered() {
        const { filterText, gangmasterList } = this
        if(!!filterText) {
          return gangmasterList.filter(item => item.name.indexOf(filterText) > -1)
        }
        return gangmasterList
      }
    },
    watch: {
      '$route.fullPath'() {
        this.init()
      }
    },
    created(){
      this.init()
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.initWechatShare()
    },
    methods: {
      init() {
        const query = this.$route.query || {}
        this.filterText = query.keyword || ''
        this.searchKeyword = query.keyword || ''
        this.getGangmasterList()
      },
      async initWechatShare(){
        let title = "水木家居商城优选工长";// 分享标题
        let desc = "水木工长，一站式工长服务，用口碑和实力技艺说话！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      DetailGangmaster(gangmaster){
        this.$router.push({name:'GangmasterDetail',query:{supervisorId:gangmaster.id,supervisorName:gangmaster.name}});
      },
      openGangmasterReservation(gangmaster){
        if(gangmaster.appointmentSwitch != '1'){
          Toast('该工长暂时不接受预约!');
        }else if(gangmaster.appointmentSwitch == '1' && gangmaster.spares == 0){
          Toast('该工长预约已满!');
        }else {
          if(!!this.global.isMiniProgrm ){
            session.isLogin().then(flag => {
              if (flag) {
                wx.miniProgram.navigateTo({url: `/pages/gangmaster/reservation?id=${gangmaster.id}&companyId=${gangmaster.companyId}&deposit=${gangmaster.deposit}&supervisorName=${gangmaster.name}`});
              } else {
                let backUrl = this.$route.fullPath;
                wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
              }
            });
          }else {
            this.$router.push({name:'GangmasterReservation',query:{id:gangmaster.id,companyId:gangmaster.companyId,supervisorName:gangmaster.name,deposit:gangmaster.deposit}});
          }
        }
      },
      async getGangmasterList(){
        this.inited = false
        let result = await SupervisorService.getSupervisorList('2');
        this.inited = true
        if(result.code == 0){
          this.gangmasterList = result.data;
        }else {
          Toast('获取工长列表信息失败');
        }
      },
      async search() {
        if(!this.searchKeyword) {
          Toast('请输入关键字后再进行搜索');
          return
        }
        this.$router.replace(`/gangmaster/seek/search?keyword=${this.searchKeyword}`)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/style/supervisor-list.scss';
  .supervisor-list {
    background: white;
    font-size: 0.36rem;
  }
  .noimg{
    text-align: center;
    .tip{
      color: #BABABA;
      font-size: .3rem;
    }
  }
  .search-container {
    width: 100%;
    .border {
      width: 100%;
      height: .2rem;
      background-color: #eee;
    }
    .search {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.2rem 0.32rem;
      .input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100px;
        height: .6rem;
        flex-grow: 1;
        flex-shrink: 1;
        background-color: #F7F7F6;
        border-radius: .05rem;
        padding: 0 .2rem;
        .search-icon{
          display: block;
          width: .3rem;
          height: .3rem;
          margin-right: .2rem;
        }
        .input-inner{
          display: block;
          width: 100%;
          height: 100%;
          background: none;
          font-size: .26rem;
          &::-webkit-input-placeholder,
          &:-moz-placeholder,
          &::-moz-placeholder,
          &:-ms-input-placeholder{
            color: #BABABA;
          }
        }
      }
      .btn {
        flex-grow: 0;
        flex-shrink: 0;
        margin-left: .2rem;
        color: #1d8ae7;
        font-size: .28rem;
      }
    }
  }
</style>

